import { AdvancedDynamicTexture, Button, Control, Rectangle, StackPanel, TextBlock } from '@babylonjs/gui';
import { Game } from '../Game';
import { Level } from '../Level';
import { Gui } from '../gui/Gui';

/**
 * Config tools for SceneViewer mode
 */
export class LevelConfigTool {
  private gui: AdvancedDynamicTexture;

  constructor(private level: Level) {}

  initialize(): void {
    this.createGUI();
  }

  private createGUI(): void {
    this.gui = AdvancedDynamicTexture.CreateFullscreenUI('LevelConfigUI', true, this.level.scene);

    // Main panel
    const panel = new Rectangle('levelConfigPanel');
    panel.width = '250px';
    panel.height = '130px';
    panel.cornerRadius = 10;
    panel.color = 'white';
    panel.thickness = 2;
    panel.background = Gui.controlBackground;
    panel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
    panel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
    panel.left = '10px';
    panel.top = '612px';
    this.gui.addControl(panel);

    // Stack panel for content
    const stack = new StackPanel('levelConfigStack');
    stack.isVertical = true;
    stack.width = '230px';
    panel.addControl(stack);

    const title = new TextBlock('title', '⚙️ Level Config');
    title.height = '30px';
    title.fontSize = 18;
    title.color = 'white';
    title.fontWeight = 'bold';
    stack.addControl(title);

    const configJsonBtn = Button.CreateSimpleButton('configJsonBtn', 'Config JSON');
    configJsonBtn.width = '100%';
    configJsonBtn.height = '35px';
    configJsonBtn.color = 'white';
    configJsonBtn.background = '#2b30c0ff';
    configJsonBtn.cornerRadius = 5;
    configJsonBtn.paddingBottom = '5px';
    configJsonBtn.onPointerUpObservable.add(() => this.createConfigJson());
    stack.addControl(configJsonBtn);

    const materialsBtn = Button.CreateSimpleButton('materialsBtn', 'Materials');
    materialsBtn.width = '100%';
    materialsBtn.height = '35px';
    materialsBtn.color = 'white';
    materialsBtn.background = '#2b30c0ff';
    materialsBtn.cornerRadius = 5;
    materialsBtn.paddingBottom = '5px';
    materialsBtn.onPointerUpObservable.add(() => this.createMaterialList());
    stack.addControl(materialsBtn);
  }

  createMaterialList(): void {
    let message = '';
    for (let i = 0; i < this.level.materials.length; i++) {
      message += i + ' : ' + this.level.materials[i].name + '\n';
    }
    Game.fireMessage(message);
  }

  createConfigJson(): void {
    const message = this.level.config.toJson();
    Game.fireMessage(message);
  }

  /**
   * Dispose the tool and clean up resources
   */
  dispose(): void {
    this.gui.dispose();
  }
}
